"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoriesSelector = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _Autocomplete = _interopRequireDefault(require("@civicplus/preamble/lib/Autocomplete/Autocomplete"));

var _react = _interopRequireWildcard(require("react"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _TypeGuards = require("../Utility/TypeGuards");

var _classnames = _interopRequireDefault(require("classnames"));

var _Alert = require("../Utility/Alert");

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var CategoriesSelector = function CategoriesSelector(props) {
  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      categories = _useState2[0],
      setCategories = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  (0, _react.useEffect)(function () {
    function load() {
      return _load.apply(this, arguments);
    }

    function _load() {
      _load = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var service, result, selectedCategories;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                service = new _sdk.CategoriesApi(props.config);
                _context.next = 3;
                return service.getCategories(props.config.appName);

              case 3:
                result = _context.sent;
                selectedCategories = props.value ? props.value.map(function (item) {
                  return result.items.find(function (w) {
                    return w.id === ((0, _TypeGuards.isString)(item) ? item : item === null || item === void 0 ? void 0 : item.id);
                  });
                }).filter(function (w) {
                  return !!w;
                }) //HCMS server currently after saving is duplicating the categories
                //This is a workaround to filter the duplicate ones
                .filter(function (val, index, self) {
                  return self.indexOf(val) === index;
                }) : []; //Currently the sdk does not have the orderBy prop. This order by can be removed once that is implemented on the sdk

                setCategories((0, _sortBy["default"])(result.items, [function (c) {
                  return c.name.toLowerCase();
                }]));
                setValue(selectedCategories);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _load.apply(this, arguments);
    }

    (0, _Alert.alertOnError)("Failed to load categories", load); // TODO: is this excluded on purpose?
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.config]);
  return /*#__PURE__*/_react["default"].createElement(_Autocomplete["default"], {
    className: (0, _classnames["default"])("prmbl-categoriesSelector", props.className),
    disabled: props.disabled,
    helperText: props.helperText,
    label: props.label,
    multiSelect: true,
    onChange: function onChange(selected) {
      var _selected, _props$onChange;

      selected = (_selected = selected) !== null && _selected !== void 0 ? _selected : [];
      var selectedCategories = selected.map(function (item) {
        return categories.find(function (w) {
          return w.id === item.value;
        });
      }).filter(function (w) {
        return w != null;
      });
      setValue(selectedCategories);
      (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, selectedCategories);
    },
    options: categories.map(function (s) {
      return {
        label: s.name,
        value: s.id
      };
    }),
    value: value.map(function (s) {
      return {
        label: s.name,
        value: s.id
      };
    })
  });
};

exports.CategoriesSelector = CategoriesSelector;
CategoriesSelector.defaultProps = {
  label: "Categories",
  value: []
};